<template lang="pug">
  .row
    .columns.large-24
      article.content-block
        header
          .title {{t(`app.programs.edit.form_part.label.${form_part.handle}`, {default: form_part.name})}}
        section.content
          template(v-if="isPresent(form_part.description)")
            p.small(v-html="to_br(form_part.description)", v-linkified)
            br
          template(v-for="form_block in form_blocks")
            tpl-panels(:form_block="form_block" :form_part="form_part")
</template>
<script>
import helpers from "../../../code/base_mixins";
import tplPanels from "./_panels"
export default{
  components: {tplPanels},
  mixins: [helpers],
  props: ["form_part", "people",],// "people" - to cleanup html
  computed: {
    form_blocks(){
      if (this.form_part.has_many_block_styles()){
        const fb = this.form_part.main_form_block()
        return fb?.to_display() ? [fb] : []
      }else{
        return this.form_part.form_blocks.filter(fb=>fb.to_display())
      }
    },
  }
}
</script>